export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const GHX_INACTIVE = 'GHX_Inactive';
